import { JobEntity, JobOperation } from '@commenda/api';
import { LoadingIndicator } from '@commenda/kakashi';
import { useIndirectTaxJobWatcher } from '../jobs';
import { DataSyncBannerProps } from './types';

const EntityNameMap = {
  [JobEntity.INVOICE]: 'Transaction',
  [JobEntity.PRODUCT]: 'Product',
  [JobEntity.CUSTOMER]: 'Customer',
};

const DataSyncBanner = ({
  corporationId,
  entity,
  isSyncInProgress = false,
}: DataSyncBannerProps) => {
  const { isJobInProgress: checkImportJobInProgress } =
    useIndirectTaxJobWatcher({
    corporation_id: corporationId,
    entity,
    operation: JobOperation.IMPORT,
  });

  const isImportJobInProgress = checkImportJobInProgress(entity);

  const { isJobInProgress: checkDeleteJobInProgress } =
    useIndirectTaxJobWatcher({
    corporation_id: corporationId,
    entity,
    operation: JobOperation.DELETE,
  });

  const isDeleteJobInProgress = checkDeleteJobInProgress(entity);

  const { isJobInProgress: checkExportJobInProgress } =
    useIndirectTaxJobWatcher({
    corporation_id: corporationId,
    entity,
    operation: JobOperation.EXPORT,
  });

  const isExportJobInProgress = checkExportJobInProgress(entity);

  return (
    <div className="h-12 flex items-center px-4 gap-3 rounded-md bg-bg-tertiary mt-3xl">
      <LoadingIndicator size={20} />
      <p className="txt-small-regular text-text-primary">
        {isSyncInProgress || isImportJobInProgress
          ? `${EntityNameMap[entity]} sync in progress`
          : isDeleteJobInProgress
            ? `${EntityNameMap[entity]} delete in progress`
            : isExportJobInProgress
              ? `${EntityNameMap[entity]} export in progress`
              : `${EntityNameMap[entity]} sync in progress`}
      </p>
    </div>
  );
};

export default DataSyncBanner;
